





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import TransactionalFeesDialogForm from '@/components/Products/ProductFees/Transactional/TransactionalFeesDialogForm.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import UpdateTransactionalFeeRequest from '@/models/Products/ProductFees/UpdateTransactionalFeeRequest';

@Component({ name: 'TransactionalFeesEditDialog', components: { TransactionalFeesDialogForm } })
export default class extends SaascadaVueDialog {

    dialog = false;
    transactionalFeeRequest: UpdateTransactionalFeeRequest = new UpdateTransactionalFeeRequest(this.currentTransactionalFee);

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.transactionalFeeRequest = new UpdateTransactionalFeeRequest(this.currentTransactionalFee);
        }
    }

    get currentTransactionalFee() {
        return ProductDetailsModule.currentTransactionalFee;
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editTransactionalFee(this.transactionalFeeRequest);
        }
    }

}
